/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
const SUPERVISED_CLASSIFICATION_WORKFLOW_AREA = {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "properties": {"areaName": "Area 1",},
            "geometry": {
              "type": "Polygon",
              "coordinates": [
                [
                  [
                    -3.269977569580078,
                    55.91842985630817
                  ],
                  [
                    -3.1221771240234375,
                    55.91842985630817
                  ],
                  [
                    -3.1221771240234375,
                    56.00097275627207
                  ],
                  [
                    -3.269977569580078,
                    56.00097275627207
                  ],
                  [
                    -3.269977569580078,
                    55.91842985630817
                  ]
                ]
              ]
            }
          },
          {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.168010711669922,
                            55.97504692455578
                        ],
                        [
                            -3.1644058227539062,
                            55.97504692455578
                        ],
                        [
                            -3.1644058227539062,
                            55.977496218762724
                        ],
                        [
                            -3.168010711669922,
                            55.977496218762724
                        ],
                        [
                            -3.168010711669922,
                            55.97504692455578
                        ],
                        [
                            -3.168010711669922,
                            55.97504692455578
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 2",},
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.236417770385742,
                            55.97351003331854
                        ],
                        [
                            -3.2312679290771484,
                            55.97351003331854
                        ],
                        [
                            -3.2312679290771484,
                            55.975767321304225
                        ],
                        [
                            -3.236417770385742,
                            55.975767321304225
                        ],
                        [
                            -3.236417770385742,
                            55.97351003331854
                        ],
                        [
                            -3.236417770385742,
                            55.97351003331854
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 2",},
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.2198524475097656,
                            55.940355960728354
                        ],
                        [
                            -3.2143592834472656,
                            55.940355960728354
                        ],
                        [
                            -3.2143592834472656,
                            55.94223064376426
                        ],
                        [
                            -3.2198524475097656,
                            55.94223064376426
                        ],
                        [
                            -3.2198524475097656,
                            55.940355960728354
                        ],
                        [
                            -3.2198524475097656,
                            55.940355960728354
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 2",},
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.201484680175781,
                            55.95693654654487
                        ],
                        [
                            -3.197107315063476,
                            55.95693654654487
                        ],
                        [
                            -3.197107315063476,
                            55.95861823830549
                        ],
                        [
                            -3.201484680175781,
                            55.95861823830549
                        ],
                        [
                            -3.201484680175781,
                            55.95693654654487
                        ],
                        [
                            -3.201484680175781,
                            55.95693654654487
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 2",},
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.152990341186523,
                            55.963278545077195
                        ],
                        [
                            -3.1492996215820312,
                            55.963278545077195
                        ],
                        [
                            -3.1492996215820312,
                            55.96529623577951
                        ],
                        [
                            -3.152990341186523,
                            55.96529623577951
                        ],
                        [
                            -3.152990341186523,
                            55.963278545077195
                        ],
                        [
                            -3.152990341186523,
                            55.963278545077195
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 2",},
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.1585693359375,
                            55.97427848656965
                        ],
                        [
                            -3.1522178649902344,
                            55.97427848656965
                        ],
                        [
                            -3.1522178649902344,
                            55.97653572971496
                        ],
                        [
                            -3.1585693359375,
                            55.97653572971496
                        ],
                        [
                            -3.1585693359375,
                            55.97427848656965
                        ],
                        [
                            -3.1585693359375,
                            55.97427848656965
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 2",},
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.1785678863525386,
                            55.922710267826176
                        ],
                        [
                            -3.1717872619628906,
                            55.922710267826176
                        ],
                        [
                            -3.1717872619628906,
                            55.924874340928305
                        ],
                        [
                            -3.1785678863525386,
                            55.924874340928305
                        ],
                        [
                            -3.1785678863525386,
                            55.922710267826176
                        ],
                        [
                            -3.1785678863525386,
                            55.922710267826176
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 2",},
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.2116610547037494,
                            55.95152205188517
                        ],
                        [
                            -3.2135418149501715,
                            55.95152205188517
                        ],
                        [
                            -3.2135418149501715,
                            55.95052715349464
                        ],
                        [
                            -3.2116610547037494,
                            55.95052715349464
                        ],
                        [
                            -3.2116610547037494,
                            55.95152205188517
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 2",},
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.2241895705029533,
                            55.948442308325696
                        ],
                        [
                            -3.2274082213208244,
                            55.948442308325696
                        ],
                        [
                            -3.2274082213208244,
                            55.94707257629265
                        ],
                        [
                            -3.2241895705029533,
                            55.94707257629265
                        ],
                        [
                            -3.2241895705029533,
                            55.948442308325696
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 2",},
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.2315115384875126,
                            55.940662047404665
                        ],
                        [
                            -3.238721316319544,
                            55.940662047404665
                        ],
                        [
                            -3.238721316319544,
                            55.93938818260801
                        ],
                        [
                            -3.2315115384875126,
                            55.93938818260801
                        ],
                        [
                            -3.2315115384875126,
                            55.940662047404665
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 2",},
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.185432289984431,
                            55.950247711026734
                        ],
                        [
                            -3.1935010871629976,
                            55.950247711026734
                        ],
                        [
                            -3.1935010871629976,
                            55.948081196080004
                        ],
                        [
                            -3.185432289984431,
                            55.948081196080004
                        ],
                        [
                            -3.185432289984431,
                            55.950247711026734
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 2",},
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.201551884204503,
                            55.94755788919784
                        ],
                        [
                            -3.207757845312711,
                            55.94755788919784
                        ],
                        [
                            -3.207757845312711,
                            55.943652108014504
                        ],
                        [
                            -3.201551884204503,
                            55.943652108014504
                        ],
                        [
                            -3.201551884204503,
                            55.94755788919784
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 2",},
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.1690406799316406,
                            55.94857505154987
                        ],
                        [
                            -3.16680908203125,
                            55.94857505154987
                        ],
                        [
                            -3.16680908203125,
                            55.950160991094734
                        ],
                        [
                            -3.1690406799316406,
                            55.950160991094734
                        ],
                        [
                            -3.1690406799316406,
                            55.94857505154987
                        ],
                        [
                            -3.1690406799316406,
                            55.94857505154987
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 3",},
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.1594276428222656,
                            55.95083379430734
                        ],
                        [
                            -3.1560802459716797,
                            55.95083379430734
                        ],
                        [
                            -3.1560802459716797,
                            55.95246769629369
                        ],
                        [
                            -3.1594276428222656,
                            55.95246769629369
                        ],
                        [
                            -3.1594276428222656,
                            55.95083379430734
                        ],
                        [
                            -3.1594276428222656,
                            55.95083379430734
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 3",},
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.2086944580078125,
                            55.9640472015588
                        ],
                        [
                            -3.2062911987304688,
                            55.9640472015588
                        ],
                        [
                            -3.2062911987304688,
                            55.96520015765537
                        ],
                        [
                            -3.2086944580078125,
                            55.96520015765537
                        ],
                        [
                            -3.2086944580078125,
                            55.9640472015588
                        ],
                        [
                            -3.2086944580078125,
                            55.9640472015588
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 3",},
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.1989097595214844,
                            55.96712167481535
                        ],
                        [
                            -3.197193145751953,
                            55.96712167481535
                        ],
                        [
                            -3.197193145751953,
                            55.968082397614296
                        ],
                        [
                            -3.1989097595214844,
                            55.968082397614296
                        ],
                        [
                            -3.1989097595214844,
                            55.96712167481535
                        ],
                        [
                            -3.1989097595214844,
                            55.96712167481535
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 3",},
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.2189083099365234,
                            55.96640111706199
                        ],
                        [
                            -3.217191696166992,
                            55.96640111706199
                        ],
                        [
                            -3.217191696166992,
                            55.96716971152182
                        ],
                        [
                            -3.2189083099365234,
                            55.96716971152182
                        ],
                        [
                            -3.2189083099365234,
                            55.96640111706199
                        ],
                        [
                            -3.2189083099365234,
                            55.96640111706199
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 3",},
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.2653427124023438,
                            55.937279361166475
                        ],
                        [
                            -3.261566162109375,
                            55.937279361166475
                        ],
                        [
                            -3.261566162109375,
                            55.939682975454566
                        ],
                        [
                            -3.2653427124023438,
                            55.939682975454566
                        ],
                        [
                            -3.2653427124023438,
                            55.937279361166475
                        ],
                        [
                            -3.2653427124023438,
                            55.937279361166475
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 3",},
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.143892288208008,
                            55.963806998048334
                        ],
                        [
                            -3.140888214111328,
                            55.963806998048334
                        ],
                        [
                            -3.140888214111328,
                            55.96582466119842
                        ],
                        [
                            -3.143892288208008,
                            55.96582466119842
                        ],
                        [
                            -3.143892288208008,
                            55.963806998048334
                        ],
                        [
                            -3.143892288208008,
                            55.963806998048334
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 3",},
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.129710517066857,
                            55.9418418057941
                        ],
                        [
                            -3.135434057738027,
                            55.9418418057941
                        ],
                        [
                            -3.135434057738027,
                            55.93893298883973
                        ],
                        [
                            -3.129710517066857,
                            55.93893298883973
                        ],
                        [
                            -3.129710517066857,
                            55.9418418057941
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 3",},
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.1498732899197845,
                            55.9368815417226
                        ],
                        [
                            -3.153258824429801,
                            55.9368815417226
                        ],
                        [
                            -3.153258824429801,
                            55.935021958235396
                        ],
                        [
                            -3.1498732899197845,
                            55.935021958235396
                        ],
                        [
                            -3.1498732899197845,
                            55.9368815417226
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 3",},
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.146365547261527,
                            55.94845686452223
                        ],
                        [
                            -3.150616848550132,
                            55.94845686452223
                        ],
                        [
                            -3.150616848550132,
                            55.94590109558619
                        ],
                        [
                            -3.146365547261527,
                            55.94590109558619
                        ],
                        [
                            -3.146365547261527,
                            55.94845686452223
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 3",},
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.144430941145262,
                            55.93048087334836
                        ],
                        [
                            -3.150596438615909,
                            55.93048087334836
                        ],
                        [
                            -3.150596438615909,
                            55.92397153151848
                        ],
                        [
                            -3.144430941145262,
                            55.92397153151848
                        ],
                        [
                            -3.144430941145262,
                            55.93048087334836
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 3",},
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.177965711131552,
                            55.956575515954206
                        ],
                        [
                            -3.183458875194052,
                            55.956575515954206
                        ],
                        [
                            -3.183458875194052,
                            55.95447327890178
                        ],
                        [
                            -3.177965711131552,
                            55.95447327890178
                        ],
                        [
                            -3.177965711131552,
                            55.956575515954206
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 3",},
        },
        {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -3.1896013223143105,
                            55.92459471336733
                        ],
                        [
                            -3.198656459948588,
                            55.92459471336733
                        ],
                        [
                            -3.198656459948588,
                            55.918727348122125
                        ],
                        [
                            -3.1896013223143105,
                            55.918727348122125
                        ],
                        [
                            -3.1896013223143105,
                            55.92459471336733
                        ]
                    ]
                ]
            },
            "properties": { "areaName": "Area 3",},
        },
        {
        "type": "Feature",
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        -3.26568603515625,
                        55.98964434616897
                    ],
                    [
                        -3.254871368408203,
                        55.98964434616897
                    ],
                    [
                        -3.254871368408203,
                        55.993868887278886
                    ],
                    [
                        -3.26568603515625,
                        55.993868887278886
                    ],
                    [
                        -3.26568603515625,
                        55.98964434616897
                    ],
                    [
                        -3.26568603515625,
                        55.98964434616897
                    ]
                ]
            ]
        },
        "properties": { "areaName": "Area 4",},
    },
    {
        "type": "Feature",
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        -3.21023941040039,
                        55.99146863646352
                    ],
                    [
                        -3.2016563415527344,
                        55.99146863646352
                    ],
                    [
                        -3.2016563415527344,
                        55.995500972706644
                    ],
                    [
                        -3.21023941040039,
                        55.995500972706644
                    ],
                    [
                        -3.21023941040039,
                        55.99146863646352
                    ],
                    [
                        -3.21023941040039,
                        55.99146863646352
                    ]
                ]
            ]
        },
        "properties": { "areaName": "Area 4",},
    },
    {
        "type": "Feature",
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        -3.2385635375976562,
                        55.98714780942223
                    ],
                    [
                        -3.2320404052734375,
                        55.98714780942223
                    ],
                    [
                        -3.2320404052734375,
                        55.990796539528226
                    ],
                    [
                        -3.2385635375976562,
                        55.990796539528226
                    ],
                    [
                        -3.2385635375976562,
                        55.98714780942223
                    ],
                    [
                        -3.2385635375976562,
                        55.98714780942223
                    ]
                ]
            ]
        },
        "properties": { "areaName": "Area 4",},
    },
    {
        "type": "Feature",
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        -3.2119560241699214,
                        55.98244235966452
                    ],
                    [
                        -3.199338912963867,
                        55.98244235966452
                    ],
                    [
                        -3.199338912963867,
                        55.98690774931648
                    ],
                    [
                        -3.2119560241699214,
                        55.98690774931648
                    ],
                    [
                        -3.2119560241699214,
                        55.98244235966452
                    ],
                    [
                        -3.2119560241699214,
                        55.98244235966452
                    ]
                ]
            ]
        },
        "properties": { "areaName": "Area 4",},
    },
    {
        "type": "Feature",
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        -3.178438857430592,
                        55.984973378097465
                    ],
                    [
                        -3.1828555336687714,
                        55.984973378097465
                    ],
                    [
                        -3.1828555336687714,
                        55.98214074868233
                    ],
                    [
                        -3.178438857430592,
                        55.98214074868233
                    ],
                    [
                        -3.178438857430592,
                        55.984973378097465
                    ]
                ]
            ]
        },
        "properties": { "areaName": "Area 4",},
    },
    {
        "type": "Feature",
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        -3.164176504360512,
                        55.99386105711313
                    ],
                    [
                        -3.1738674722146243,
                        55.99386105711313
                    ],
                    [
                        -3.1738674722146243,
                        55.989951404472606
                    ],
                    [
                        -3.164176504360512,
                        55.989951404472606
                    ],
                    [
                        -3.164176504360512,
                        55.99386105711313
                    ]
                ]
            ]
        },
        "properties": { "areaName": "Area 4",},
    },
    {
        "type": "Feature",
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        -3.1380487920250744,
                        55.99396731577014
                    ],
                    [
                        -3.145971744088456,
                        55.99396731577014
                    ],
                    [
                        -3.145971744088456,
                        55.988747425302336
                    ],
                    [
                        -3.1380487920250744,
                        55.988747425302336
                    ],
                    [
                        -3.1380487920250744,
                        55.99396731577014
                    ]
                ]
            ]
        },
        "properties": { "areaName": "Area 4",},
    },
    {
        "type": "Feature",
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        -3.1380160187836736,
                        55.97856190486126
                    ],
                    [
                        -3.1458570167887956,
                        55.97856190486126
                    ],
                    [
                        -3.1458570167887956,
                        55.97526938688371
                    ],
                    [
                        -3.1380160187836736,
                        55.97526938688371
                    ],
                    [
                        -3.1380160187836736,
                        55.97856190486126
                    ]
                ]
            ]
        },
        "properties": { "areaName": "Area 4",},
    }
    ]
};

export default SUPERVISED_CLASSIFICATION_WORKFLOW_AREA;

